import React from 'react';
import Todo from './Todo';
import { Droppable } from 'react-beautiful-dnd';

const TodoList = ({ todos, setTodos, filteredTodos }) => {
  return (
    <div className="todo-container">
      <Droppable droppableId="todos">
        {(provided) => (
          <ul className="todo-list" {...provided.droppableProps} ref={provided.innerRef}>
            {filteredTodos.map((todo, index) => (
              <Todo
                setTodos={setTodos}
                todos={todos}
                todo={todo}
                key={todo.id}
                text={todo.text}
                completed={todo.completed}
                id={todo.id}
                index={index}
              />
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </div>
  );
};

export default TodoList;
